var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t\t2.6,10 2.6,1.6 13.4,1.5 10.7,5.6 12.8,9.9 \t\t"})),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"2.6","y1":"15","x2":"2.6","y2":"1","key":1})]));
}

Flag.displayName = "Flag";

Flag.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Flag;

Flag.default = Flag;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/flag.svg
// module id = ../icon/src/icons/flag.svg
// module chunks = 0